<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
  style="top: 80px"
>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
    <mat-tab-group
      mat-align-tabs="center"
      [selectedIndex]="indexTabs.value"
      (selectedIndexChange)="indexTabs.setValue($event)"
    >
      <mat-tab label="Customer">
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
        >
          <div [formGroup]="placeForm">
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                row
              "
            >
              <h3
                class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                "
              >
                Customer Info
              </h3>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Company Name</mat-label>
                  <input
                    matInput
                    placeholder="Company name"
                    formControlName="CompanyName"
                    maxlength="100"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Address</mat-label>
                  <input
                    matInput
                    placeholder="Address"
                    formControlName="Address"
                    maxlength="100"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Address 1 (Ste#, Bldg#, Etc..)</mat-label>
                  <input
                    matInput
                    placeholder="Address 1 (Ste#, Bldg#, Etc..)"
                    formControlName="Address1"
                    maxlength="100"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>City</mat-label>
                  <input matInput placeholder="City" formControlName="City" max="75"/>
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>State</mat-label>
                  <input matInput placeholder="State" formControlName="State" maxlength="50" />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Zip Code</mat-label>
                  <input
                    matInput
                    placeholder="Zip code"
                    formControlName="ZipCode"
                    maxlength="50"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Phone</mat-label>
                  <input matInput placeholder="Phone" formControlName="Phone" maxlength="20"/>
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Fax</mat-label>
                  <input matInput placeholder="Fax" formControlName="Fax" maxlength="20"/>
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
                style="margin-top: 2.5vh"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Email</mat-label>
                  <input matInput placeholder="Email" formControlName="Email" maxlength="100" />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
                style="margin-top: 2.5vh"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Web Site</mat-label>
                  <input
                    matInput
                    placeholder="Web site"
                    formControlName="Website"
                    maxlength="100"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill">
                  <mat-label>Payment Terms</mat-label>
                  <mat-select
                 
                   
                    formControlName="selPayment"
                    
                  >
                    <mat-option value="0">Due on receipt</mat-option>
                    <mat-option value="1">7 Days</mat-option>
                    <mat-option value="2">15 Days</mat-option>
                    <mat-option value="3">30 Days</mat-option>
                    <mat-option value="4">45 Days</mat-option>
                    <mat-option value="5">60 Days</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill">
                  <mat-label>Billing Type </mat-label>
                  <mat-select
                  
                    formControlName="selBilling"
                  >
                  
                    <mat-option value="0">Invoice per order</mat-option>
                    <mat-option value="1">Bulk billing</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <mat-divider></mat-divider>
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                row
              "
            >
              <h3
                class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                "
              >
                Operations Contact
              </h3>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Contact Name</mat-label>
                  <input
                    matInput
                    placeholder="Contact name"
                    formControlName="Contactname"
                    maxlength="50"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Contact Last Name</mat-label>
                  <input
                    matInput
                    placeholder="Contact last name"
                    formControlName="Contactlastname"
                    maxlength="50"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Email</mat-label>
                  <input matInput placeholder="Email" formControlName="ContactEmail" maxlength="50" />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Fax</mat-label>
                  <input matInput placeholder="Fax" formControlName="ContactFax" maxlength="20" />
                </mat-form-field>
              </div>
              <div
              class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
            >
              <mat-form-field class="example-full-width">
                <mat-label>Phone</mat-label>
                <input matInput placeholder="Phone" formControlName="ContactPhone" maxlength="20" />
              </mat-form-field>
            </div>
            </div>
            <mat-divider></mat-divider>
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                row
              "
            >
              <h3
                class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                "
              >
                Payables Contact
              </h3>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Contact Name</mat-label>
                  <input
                    matInput
                    placeholder="Contact name"
                    formControlName="PayablesContactname"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Contact Last Name</mat-label>
                  <input
                    matInput
                    placeholder="Contact last name"
                    formControlName="PayablesContactlastname"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Email</mat-label>
                  <input
                    matInput
                    placeholder="Email"
                    formControlName="PayablesEmail"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Fax</mat-label>
                  <input matInput placeholder="Fax" formControlName="PayablesFax" />
                </mat-form-field>
              </div>
              <div
              class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
            >
              <mat-form-field class="example-full-width">
                <mat-label>Phone</mat-label>
                <input matInput placeholder="Fax" formControlName="PayablesPhone" />
              </mat-form-field>
            </div>
            </div>
            <mat-divider></mat-divider>
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                row
              "
            >
              <h3
                class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                "
              >
                Parcel Carriers Accounts
              </h3>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>UPS Account #</mat-label>
                  <input
                    matInput
                    placeholder="UPS account"
                    formControlName="UPSAccount"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>FedEx Account #</mat-label>
                  <input
                    matInput
                    placeholder="FedEx account"
                    formControlName="FedExAccount"
                  />
                </mat-form-field>
              </div>
            </div>
            <mat-divider></mat-divider>
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                row
              "
            >
              <h3
                class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                "
              >
                Billing
              </h3>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Storage Free Days</mat-label>
                  <input
                    matInput
                    placeholder="Storage free days"
                    formControlName="StorageFreeDays"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-checkbox
                  class="example-margin"
                  [(ngModel)]="checked"
                  formControlName="Activate"
                  >Active</mat-checkbox
                >
              </div>
              <div
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 "
                style="text-align: center"
              >
              <button
              mat-raised-button
              color="danger"
              class="
                col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
              "
        
              (click)="OnClear()"
            >
              Cancel
            </button>
                <button
                  mat-raised-button
                  color="primary"
                  class="
                  col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                  "
                  *ngIf="saveCustomer"
                  (click)="OnInsertCustomer()"
                >
                  Save Customer
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  class="
                  col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                  "
                  *ngIf="editCustomer"
                  (click)="OnInsertCustomer()"
                >
                  Save
                </button>
              </div>
            </div>
            <mat-divider></mat-divider>
          </div>
        </div>
      </mat-tab>
      <mat-tab *ngIf="false" label="Contacts">
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
        >
         
        </div>
      </mat-tab>
      <mat-tab *ngIf="false" label="Warehouse"
        >Please choose the warehouses where items are stored for this customer.
        Also, choose the one warehouse where most of the items are stored for
        this customer. For convenience, the Primary Warehouse is initially
        selected when receiving and shipping for this customer, but that
        selection can be changed to any of the other warehouses checked
        here.</mat-tab
      >
      <mat-tab label="Search customer" [disabled]="tab2">
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-form-field class="example-full-width">
              <mat-label>Select An Option</mat-label>
              <mat-select (selectionChange)="OnChangeSearch($event.value)">
                <mat-option
                  *ngFor="let active of actives"
                  [value]="active.value"
                >
                  {{ active.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
            *ngIf="viewTableCustomer"
          >
            <mat-form-field appearance="outline">
              <input
                (keyup)="applyFilter($event.target.value)"
                #input
                matInput
                placeholder="Search"
              />
              <button
                mat-button
                matSuffix
                mat-icon-button
                (click)="openDialogLector()"
                color="primary"
                aria-label="Example icon button with a menu icon"
              >
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
              <mat-hint>Filter Table</mat-hint>
            </mat-form-field>
            <div
              class="
                example-container
                mat-elevation-z8
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
            >
            <button
            mat-button
            matSuffix
            mat-icon-button
            color="success"
            (click)="exportAsExcel()"
            aria-label="Example icon button with a menu icon"
            class="col-md-12"
          >Excel
        
            <mat-icon>cloud_download</mat-icon>
          </button>
              <div class="example-table-container" #exportExcel>
                <table
                  mat-table
                  [dataSource]="dataSourceSearch"
                  class="example-table"
                  matSort
                  matSortDirection="desc"
                  #TableSearchCustomerSort="matSort"
                >
                  <!-- ID Column -->
                  <ng-container matColumnDef="id" sticky>
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      disableClear
                    >
                      Options
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <button mat-icon-button [matMenuTriggerFor]="menuT" aria-label="Example icon-button with a menu">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menuT="matMenu">
                        <button mat-menu-item (click)="editarCust(row)">
                       
                          <span>Edit</span>
                        </button>
                       
                        <button mat-menu-item (click)="openDialogPayorAdd(row.id)">
                        
                          <span>Add Payor</span>
                        </button>
                      </mat-menu>
                      
                     
                     
                    </td>
                  </ng-container>

                  <!-- Progress Column -->
                  <ng-container matColumnDef="Customer">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">    Customer</div>

                    </th>
                    <td mat-cell *matCellDef="let row">
                  <div class="theadTable">   {{row.Company_Name}}</div>

                    </td>
                  </ng-container>

                  <!-- Name Column -->
                  <ng-container matColumnDef="Address">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">   Address</div>

                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{row.Company_Address}}</div>
                     
                    </td>
                  </ng-container>

                  <!-- Color Column -->
                  <ng-container matColumnDef="Phone">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Phone
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{row.Company_Phone}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="Active" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Active
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ row.Active }}
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">
                      No Data Matching The Filter "{{ input.value }}"
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <mat-paginator
              [length]="resultsLength"
              #TableSearchCustomerPaginator="matPaginator"
              [pageSizeOptions]="[50, 100, 250, 1000,10000]"
              [pageSize]="50"
            ></mat-paginator>
          </div></div
      ></mat-tab>
    </mat-tab-group>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
></ngx-spinner>
